import { openModal } from 'controls/react/ant/antModal';
import { observer } from 'mobx-react';
import { DashboardsTree } from 'areas/dashboards/pages/DashboardsPage/components/DashboardsTree/index';
import React, { useCallback, useMemo } from 'react';
import { translator } from 'core/localization';
import { GridStore } from 'controls/grid/gridStore';
import { DashboardsListEntry } from 'areas/dashboards/dashboards-grid-store/types';
import { RemoteDataProvider } from 'controls/grid/remoteDataProvider';
import { getDashboards, getDashboardsListFilters } from 'areas/dashboards/dashboards-grid-store/api';
import { observable } from 'mobx';
import { Section } from 'controls/react/layout/section';

const i18n = translator({
	'Select': {
		no: 'Velg',
	},
	'Select folder': {
		no: 'Velg mappe',
	},
});

export const openTreeListPopup = async ({
	onOk,
	dashboardGridStore,
}: {
	onOk?: (path: string) => void;
	dashboardGridStore?: GridStore<DashboardsListEntry>;
}) => {
	const resultWrapper = {
		path: '',
	};
	const gridStore =
		dashboardGridStore ??
		observable(
			new GridStore<DashboardsListEntry>({
				columns: [],
				dataProvider: new RemoteDataProvider({
					dataSource: () => getDashboards(),
				}),
				filtersConfiguration: getDashboardsListFilters(),
			}),
		);
	const { promise } = openModal(
		{
			onOk: () => {
				onOk?.(resultWrapper.path);
			},
			title: i18n('Select folder'),
			okText: i18n('Select'),
			closable: true,
			draggable: true,
			width: 400,
			mask: { closable: true },
		},
		<TreeListPopup resultWrapper={resultWrapper} dashboardGridStore={gridStore} />,
	);
	await promise;
	if (!dashboardGridStore) {
		gridStore.destroy();
	}
};

const TreeListPopup = observer(
	({
		dashboardGridStore,
		resultWrapper,
	}: {
		dashboardGridStore: GridStore<DashboardsListEntry>;
		resultWrapper: { path: string };
	}) => {
		const onChangePath = useCallback((path: string) => {
			resultWrapper.path = path;
		}, []);
		const settings = useMemo(() => ({ hideLeafs: true, disableDragAndDrop: true, disableDelete: true }), []);
		return (
			<Section
				appearance={'none'}
				contentPadding={true}
				overlaySpinner={!dashboardGridStore.dataProvider.initialized}
				contentOverlay={!dashboardGridStore.dataProvider.initialized}
			>
				{dashboardGridStore.dataProvider.initialized && (
					<DashboardsTree settings={settings} gridStore={dashboardGridStore} onSelect={onChangePath} />
				)}
			</Section>
		);
	},
);
